// hooks/useCodedParagraph.js - New hook for individual paragraph coding
import { useMemo } from 'react';
import { getCodedParagraph } from 'utils/ParagraphUtils';

export const useCodedParagraph = (
  paragraph,
  excerpts,
  speakerColorHash,
  primeCode,
  effectiveSelect = null,
  selectedExcerptId = null,
  extraBoundaries = null
) => {
  return useMemo(() => {
    if (!paragraph) return null;

    return getCodedParagraph(
      paragraph,
      excerpts,
      speakerColorHash,
      effectiveSelect,
      primeCode,
      selectedExcerptId,
      extraBoundaries
    );
  }, [paragraph, excerpts, speakerColorHash, primeCode, effectiveSelect, selectedExcerptId, extraBoundaries]);
};